var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJewelryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12L10.8905 8.87597C10.9815 8.14798 11.3125 8 12 8C12.6875 8 13.0185 8.14798 13.1095 8.87597L13.5 12",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 3C22.75 2.58579 22.4142 2.25 22 2.25C21.5858 2.25 21.25 2.58579 21.25 3H22.75ZM2.75 3C2.75 2.58579 2.41421 2.25 2 2.25C1.58579 2.25 1.25 2.58579 1.25 3H2.75ZM15.7781 8.78359C15.3824 8.90615 15.161 9.32626 15.2836 9.72193C15.4062 10.1176 15.8263 10.339 16.2219 10.2164L15.7781 8.78359ZM7.77808 10.2164C8.17374 10.339 8.59385 10.1176 8.71642 9.72193C8.83898 9.32626 8.61759 8.90615 8.22193 8.78359L7.77808 10.2164ZM21.25 3C21.25 5.44217 19.1493 7.73927 15.7781 8.78359L16.2219 10.2164C19.9143 9.07261 22.75 6.37249 22.75 3H21.25ZM8.22193 8.78359C4.8507 7.73927 2.75 5.44217 2.75 3H1.25C1.25 6.37249 4.08568 9.07261 7.77808 10.2164L8.22193 8.78359Z",
    fill: "#19425A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26872 12.4971C9.60954 11.6746 10.7798 12.0061 11.4828 12.534C11.7711 12.7505 11.9152 12.8587 12 12.8587C12.0848 12.8587 12.2289 12.7505 12.5172 12.534C13.2202 12.0061 14.3905 11.6746 15.7313 12.4971C17.491 13.5765 17.8891 17.1374 13.8302 20.1417C13.0571 20.7139 12.6706 21 12 21C11.3294 21 10.9429 20.7139 10.1698 20.1417C6.11086 17.1374 6.50903 13.5765 8.26872 12.4971Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelryIcon);
export default __webpack_public_path__ + "static/media/jewelry-icon.19835be5d83d57796997fb2eb434620f.svg";
export { ForwardRef as ReactComponent };